import React, { useState, useEffect } from 'react';

import Navbar from '../../components/navbar';
import Footer from '../../components/footer';
import { useNavigate } from 'react-router-dom';
import { productService } from '../../service/productservice';

import maameYaaBankuFlour from "../../public/category-img/flour/maame-yaa-plantain-flour_prev_ui.png";
import oloyeWheatFlour4lb from "../../public/category-img/flour/Oloye_Wheat_Fufu-1-floor_prev_ui.png";

import ayoolaCassavaFlour2lb from "../../public/category-img/flour/ayoola-floor-fufu_prev_ui.png";
import maameYaaPlantainFlour4lb from "../../public/category-img/flour/maame-yaa-plantain-flour_prev_ui.png";
import ayoolaPlantainFlour09kg from "../../public/category-img/flour/ayoola-platain-floor_prev_ui.png";
import tropiwayPlantainFlour24oz from "../../public/category-img/flour/tropiway-plantain-floor_prev_ui.png";
import africanBestBeansFlour22lb from "../../public/category-img/flour/african-best-beans-floor_prev_ui.png";
import oloyeBeansFlour2lb from "../../public/category-img/flour/oloye-beans-flour_prev_ui.png";
import ayoolaBeansFlour2kg from "../../public/category-img/flour/ayoola-beans-flour_prev_ui.png";
import oloyeOatFufu2lb from "../../public/category-img/flour/oloye-oat-fufu-flour_prev_ui.png";
import oloyePoundedYam2lb from "../../public/category-img/flour/oloye-pounded-yam2.jpg";
import ayoolaPoundedYam2lb from "../../public/category-img/flour/ayoola-pounded-yam-flour_prev_ui.png";
// import nittemonYamFlour4lb from "../../public/category-img/flour/nittemon-yam-flour-4lb.png";
import checkersCornFlour400g from "../../public/category-img/flour/checkers-corn-flour_prev_ui.png";
import goldenPennySemovita500g from "../../public/category-img/flour/golden-penny-semovita-flour_prev_ui.png";
import obijiCocoyamflour8oz from "../../public/category-img/flour/cocoyam_prev_ui.png";
//import obijiCocoyamFlour8oz from "../../public/category-img/flour/obiji-cocoyam-flour-8oz.png";



import floor from "../../public/category-img/floor2_prev_ui.png"

export const flourproducts = [
  { id: 'FLR001', name: 'Maame-Yaa Banku Flour 2lb', brand: 'Maame-Yaa', price: '$5.95', img: maameYaaBankuFlour, description: 'Maame Yaa Banku Flour is a premium, finely milled flour made from high-quality corn and cassava. Perfect for preparing the traditional Ghanaian dish, Banku, which is a smooth, fermented dough-like meal often served with soups and stews.' },
  { id: 'FLR002', name: 'Maame-Yaa Banku Flour 10Lb', brand: 'Maame-Yaa', price: '$29.95', img: maameYaaBankuFlour, description: 'Maame Yaa Banku Flour is a premium, finely milled flour made from high-quality corn and cassava. Perfect for preparing the traditional Ghanaian dish, Banku, which is a smooth, fermented dough-like meal often served with soups and stews.' },
  { id: 'FLR003', name: 'Oloye Wheat Flour 4Lb', brand: 'Oloye', price: '$6.95', img: oloyeWheatFlour4lb, description: 'Oloye Wheat Flour is a premium, finely milled flour made from high-quality wheat, perfect for a wide range of cooking applications. Known for its smooth texture and versatility, it ensures consistent results in various dishes.' },
  { id: 'FLR004', name: 'Oloye Wheat Flour 10Lb', brand: 'Oloye', price: '$16.55', img: oloyeWheatFlour4lb, description: 'Oloye Wheat Flour is a premium, finely milled flour made from high-quality wheat, perfect for a wide range of cooking applications. Known for its smooth texture and versatility, it ensures consistent results in various dishes.' },
  { id: 'FLR005', name: 'Ayoola Cassava Flour (Akpu) 2Lb', brand: 'Ayoola', price: '$4.14', img: ayoolaCassavaFlour2lb, description: 'Ayoola Cassava Flour is a premium, gluten-free flour made from finely milled cassava root. Perfect for those following gluten-free diets and offers a smooth texture ideal for baking, thickening, and making traditional dishes.' },
  { id: 'FLR006', name: 'Ayoola Cassava Flour (Akpu) 4.4Lb', brand: 'Ayoola', price: '$16.95', img: ayoolaCassavaFlour2lb, description: 'Ayoola Cassava Flour is a premium, gluten-free flour made from finely milled cassava root. Perfect for those following gluten-free diets and offers a smooth texture ideal for baking, thickening, and making traditional dishes.' },
  { id: 'FLR008', name: 'Maame-Yaa Plantain Flour 4LB', brand: 'Maame-Yaa', price: '$11.95', img: maameYaaPlantainFlour4lb, description: 'Maame Yaa Plantain Flour is a premium, gluten-free flour made from finely milled green plantains. It offers a smooth, versatile texture perfect for a variety of dishes, including baked goods, porridge, and thickening sauces.' },
  { id: 'FLR009', name: 'Maame-Yaa Plantain Flour 10LB', brand: 'Maame-Yaa', price: '$23.95', img: maameYaaPlantainFlour4lb, description: 'Maame Yaa Plantain Flour is a premium, gluten-free flour made from finely milled green plantains. It offers a smooth, versatile texture perfect for a variety of dishes, including baked goods, porridge, and thickening sauces.' },
  { id: 'FLR010', name: 'Ayoola Plantain Flour 0.9kg', brand: 'Ayoola', price: '$3.25', img: ayoolaPlantainFlour09kg, description: 'Ayoola Plantain Flour is a high-quality, gluten-free flour made from carefully processed green plantains. It has a smooth texture and is ideal for baking, cooking, and making traditional dishes.' },
  { id: 'FLR011', name: 'Tropiway Plantain Flour 24oz', brand: 'Tropiway', price: '$4.90', img: tropiwayPlantainFlour24oz, description: 'Tropiway Plantain Flour is a premium, gluten-free flour made from finely milled green plantains. It has a smooth texture, making it ideal for baking, thickening, and preparing traditional dishes.' },
  { id: 'FLR012', name: 'African Best Beans Flour 2.2Lb', brand: 'African Best', price: '$9.95', img: africanBestBeansFlour22lb, description: 'African Best Bean Flour is a high-quality, finely milled flour made from carefully selected beans. Rich in protein, fiber, and essential nutrients, its perfect for a variety of dishes, such as bean cakes, fritters, and other savory meals.' },
  { id: 'FLR013', name: 'Oloye Beans Flour 2Lb', brand: 'Oloye', price: '$9.50', img: oloyeBeansFlour2lb, description: 'Oloye Bean Flour is a premium, finely milled flour made from high-quality beans. Packed with protein, fiber, and essential nutrients, its perfect for creating a variety of savory dishes like fritters, cakes, and bean-based snacks.' },
  { id: 'FLR014', name: 'Ayoola Beans Flour 4.41 lb', brand: 'Ayoola Beans', price: '$12.11', img: ayoolaBeansFlour2kg, description: 'Ayoola Bean Flour is a high-quality, finely milled flour made from carefully selected beans. Rich in protein, fiber, and essential nutrients, it is ideal for making a variety of savory dishes like fritters, bean cakes, and snacks.' },
  { id: 'FLR015', name: 'Oloye Oat Fufu 2Lb', brand: 'Oloye', price: '$4.95', img: oloyeOatFufu2lb, description: 'Oloye Oat Fufu is a premium, easy-to-prepare alternative to traditional fufu made from finely milled oats. It has a smooth, stretchy texture that makes it perfect for pairing with your favorite soups and stews.' },
  { id: 'FLR016', name: 'Oloye Oat Fufu 10Lb', brand: 'Oloye', price: '$16.55', img: oloyeOatFufu2lb, description: 'Oloye Oat Fufu is a premium, easy-to-prepare alternative to traditional fufu made from finely milled oats. It has a smooth, stretchy texture that makes it perfect for pairing with your favorite soups and stews.' },
  { id: 'FLR018', name: 'Oloye Pounded Yam 2Lb', brand: 'Oloye', price: '$5.95', img: oloyePoundedYam2lb, description: 'Oloye Pounded Yam is a premium, easy-to-prepare flour made from carefully selected yams. It offers a smooth, stretchy texture when prepared, making it a perfect substitute for traditionally pounded yam.' },
  { id: 'FLR019', name: 'Oloye Pounded Yam 10Lb', brand: 'Oloye', price: '$22.55', img: oloyePoundedYam2lb, description: 'Oloye Pounded Yam is a premium, easy-to-prepare flour made from carefully selected yams. It offers a smooth, stretchy texture when prepared, making it a perfect substitute for traditionally pounded yam.' },
  { id: 'FLR020', name: 'Ayoola Pounded Yam 2Lb', brand: 'Ayoola', price: '$9.90', img: ayoolaPoundedYam2lb, description: 'Ayoola Pounded Yam is a high-quality, easy-to-prepare flour made from carefully processed yams. It delivers a smooth, stretchy texture similar to traditionally pounded yam, making it perfect for pairing with your favorite soups and stews.' },
  { id: 'FLR021', name: 'Nittemon Food Yam Flour 4Lb', brand: 'Nittemon Food', price: '3.00', img: floor, description: 'Nittemon Food Yam Flour is a premium, finely milled flour made from high-quality yams. It offers a smooth, stretchy texture when prepared, making it an excellent alternative to traditional pounded yam.' },
  { id: 'FLR022', name: 'Checkers Corn Flour 0.88 lb', brand: 'Checkers', price: '$1.65', img: checkersCornFlour400g, description: 'Checkers Corn Flour is a premium, finely milled flour made from high-quality corn. Its smooth texture is perfect for making creamy custards, puddings, and other sweet treats.' },
  { id: 'FLR023', name: 'Golden Penny Semovita 1.1 lb', brand: 'Golden Penny', price: '$1.42', img: goldenPennySemovita500g, description: 'Golden Penny Semovita is a premium semovita flour made from carefully selected durum wheat. Known for its smooth, fluffy texture, it is perfect for making the popular Nigerian dish, semovita.' },
  { id: 'FLR024', name: 'Golden Penny Semovita 2.2 lb', brand: 'Golden Penny', price: '$1.14', img: goldenPennySemovita500g, description: 'Golden Penny Semovita is a premium semovita flour made from carefully selected durum wheat. Known for its smooth, fluffy texture, it is perfect for making the popular Nigerian dish, semovita.' },
  { id: 'FLR025', name: 'Golden Penny Semovita 4.41 lb', brand: 'Golden Penny', price: '$3.25', img: goldenPennySemovita500g, description: 'Golden Penny Semovita is a premium semovita flour made from carefully selected durum wheat. Known for its smooth, fluffy texture, it is perfect for making the popular Nigerian dish, semovita.' },
  { id: 'FLRO26', name: 'Golden Penny Semovita 11.02 lb', brand: 'Golden Penny', price: '$6.85', img: goldenPennySemovita500g, description: 'Golden Penny Semovita is a premium semovita flour made from carefully selected durum wheat. Known for its smooth, fluffy texture, it is perfect for making the popular Nigerian dish, semovita.' },
  { id: 'FLR027', name: 'Cocoyam Flour 8oz', brand: 'Obiji Food', price: '$5.99', img: obijiCocoyamflour8oz, description: 'Obiji Cocoyam Flour is a premium flour made from finely milled cocoyam, known for its smooth texture and natural, earthy flavor. Its perfect for making traditional dishes like cocoyam pounded yam or thickening soups and stews.' }
];

const ProductCard = ({ product, updateCartCount, forceUpdateKey }) => {
  const [inCart, setInCart] = useState(false);
  const [quantity, setQuantity] = useState(0);
  const navigate = useNavigate();

  useEffect(() => {
    const storedCartItems = JSON.parse(localStorage.getItem('cartItems')) || [];
    const foundItem = storedCartItems.find((item) => item.id === product.id);
    if (foundItem) {
      setInCart(true);
      setQuantity(foundItem.quantity);
    } else {
      setInCart(false);
      setQuantity(0);
    }
  }, [product.id, forceUpdateKey]);

  const handleAddToCart = () => {
    if (!inCart) {
      setInCart(true);
      setQuantity(1);
      saveToLocalStorage(product, 1);
      updateCartCount();
    }
  };

  const handleProductClick = () => {
    navigate(`/product/${product.name}`);
  };

  const saveToLocalStorage = (product, quantity) => {
    const cartItems = JSON.parse(localStorage.getItem('cartItems')) || [];
    const updatedCart = [...cartItems, { ...product, quantity }];
    localStorage.setItem('cartItems', JSON.stringify(updatedCart));
  };

  return (
    <div className="bg-white shadow-md rounded-lg p-3 w-full flex flex-col justify-between">
      <div onClick={handleProductClick} className="relative cursor-pointer flex justify-center items-center">
        <img
          src={product.img}
          alt={product.name}
          className={`h-60 w-full object-cover rounded-lg ${product.quantity === 0 ? 'opacity-50' : ''}`}
        />
        {product.quantity === 0 && (
          <div className="absolute inset-0 bg-black bg-opacity-50 flex items-center justify-center rounded-lg">
            <span className="text-white text-lg font-semibold">Out of Stock</span>
          </div>
        )}
      </div>
      <div className="mt-4">
        <h3 className="text-lg font-semibold">{product.name}</h3>
        <p className="text-[#007D44]">{product.brand}</p>
        <p className="text-[#007D44] font-bold mt-2">${product.price}</p>
      </div>
      {inCart ? (
        <div className="mt-4 flex items-center justify-between border bg-slate-100 shadow-md rounded-full">
          <button
            onClick={() => {
              if (quantity > 1) {
                setQuantity((prevQuantity) => prevQuantity - 1);
                updateCartCount();
              }
            }}
            className="bg-[#38c13a] text-white py-2 px-4 rounded-lg hover:bg-[#2e9830]"
          >
            -
          </button>
          <span className="text-lg font-semibold">{quantity}</span>
          <button
            onClick={() => {
              setQuantity((prevQuantity) => prevQuantity + 1);
              updateCartCount();
            }}
            className="bg-[#227d24] text-white py-2 px-4 rounded-lg hover:bg-[#007D44]"
          >
            +
          </button>
        </div>
      ) : (
        <button
          onClick={handleAddToCart}
          className={`mt-4 bg-[#227d24] text-white py-2 px-4 rounded-lg hover:bg-[#007D44] ${
            product.quantity === 0 ? 'cursor-not-allowed opacity-50' : ''
          }`}
          disabled={product.quantity === 0}
        >
          Add to cart
        </button>
      )}
    </div>
  );
};


const FlourProducts = () => {
  const [cartCount, setCartCount] = useState(0);
  const [forceUpdateKey, setForceUpdateKey] = useState(0);


  const [uploadStatus, setUploadStatus] = useState(null);
  const [isUploading, setIsUploading] = useState(false);
  const [cloudinaryUrls, setCloudinaryUrls] = useState({});
  const [products, setProducts] = useState([]);
    const [hasIncompatibleItems, setHasIncompatibleItems] = useState(false); // New state
      
  

 // Auto-upload products when component mounts
 useEffect(() => {
  const uploadProducts = async () => {
    try {
      setIsUploading(true);

      // Prepare products for upload
      const productsToUpload = flourproducts.map(product => ({
        ...product,
        id: product.id,
        name: product.name,
        brand: product.brand,
        description: product.description,
        category: 'flourproducts',
        quantity: 0,
        price: parseFloat(product.price.replace('$', ''))
      }));

      try {
        const result = await productService.bulkCreateProducts(productsToUpload);
        
        setUploadStatus({
          success: true,
          message: `${result.created} beauty products uploaded successfully`
        });
      } catch (error) {
        setUploadStatus({
          success: false,
          message: error.response?.data?.message || 'Product upload failed'
        });
      }
    } catch (error) {
      console.error('Error uploading products:', error);
      setUploadStatus({
        success: false,
        message: 'Failed to upload products'
      });
    } finally {
      setIsUploading(false);
    }
  };


  // Fetch products by category
  const fetchProducts = async () => {
    try {
      const result = await productService.getProductsByCategory('flourproducts');
      
      // If no products exist, trigger upload
      if (result.count === 0) {
        await uploadProducts();
      } else {
        setProducts(result.products);
        console.log(result.products)
      }
    } catch (error) {
      console.error('Error fetching products:', error);
    }
  };

  fetchProducts();
}, []);

 

   useEffect(() => {
     const storedCartItems = JSON.parse(localStorage.getItem('cartItems')) || [];
     setCartCount(storedCartItems.reduce((acc, item) => acc + item.quantity, 0));
     
     // Check for incompatible items on initial load
     const hasIncompatible = storedCartItems.some(item => 
       ["Large Box", "Small Box", "Discount"].includes(item.orderType)
     );
     setHasIncompatibleItems(hasIncompatible);
 
   }, []);
 
   const updateCartCount = () => {
     const storedCartItems = JSON.parse(localStorage.getItem('cartItems')) || [];
     setCartCount(storedCartItems.reduce((acc, item) => acc + item.quantity, 0));
     
     // Check for incompatible items whenever cart updates
     const hasIncompatible = storedCartItems.some(item => 
       ["Large Box", "Small Box", "Discount"].includes(item.orderType)
     );
     setHasIncompatibleItems(hasIncompatible);
   };

  const forceUpdateProducts = () => {
    setForceUpdateKey(prevKey => prevKey + 1); // This will force a re-render in ProductCard
  };

  return (
    <>
      <Navbar cartCount={cartCount} updateCartCount={updateCartCount} forceUpdateProducts={forceUpdateProducts} /> {/* Pass cart count to Navbar */}

      {/* Upload Status Notification */}
      {isUploading && (
        <div className="fixed top-0 left-0 w-full bg-yellow-500 text-white text-center py-2 z-50">
          Uploading sponge products...
        </div>
      )}
      
      {uploadStatus && (
        <div 
          className={`
            fixed 
            top-0 
            left-0 
            w-full 
            text-center 
            py-2 
            z-50 
            ${uploadStatus.success ? 'bg-green-500' : 'bg-red-500'} 
            text-white
          `}
        >
          {uploadStatus.message}
        </div>
      )}

      <div className="min-h-screen p-8 max-sm:p-1 lg:mt-[70px] mt-[130px]">
      {hasIncompatibleItems && (
        <div className="bg-red-100 border border-red-400 text-red-700 px-4 py-3 rounded relative mb-4">
          <span className="block sm:inline">
            Your cart contains items from a different box type. Please complete your current order 
            or clear the cart before selecting individual sponge products.
          </span>
          <button
            onClick={() => setHasIncompatibleItems(false)}
            className="absolute top-0 right-0 px-2 py-1"
          >
            ×
          </button>
        </div>
      )}
        <div className="flex justify-between items-center max-sm:flex-col max-sm:items-start mb-6">
          <h3 className="text-2xl font-semibold">Flour Products</h3>
        </div>
        <div className="grid grid-cols-2 sm:grid-cols-2 md:grid-cols-3 lg:grid-cols-4 xl:grid-cols-4 gap-6">
          {products.map(product => (
            <ProductCard
              key={product.id}
              product={product}
              updateCartCount={updateCartCount}
              forceUpdateKey={forceUpdateKey} // Pass updateCartCount to ProductCard
            />
          ))}
        </div>
      </div>
      <Footer />
    </>
  );
};

export default FlourProducts;